module.exports = require('component-delegate');


// WEBPACK FOOTER //
// ./~/min-dom/lib/delegate.js